import React from 'react';
import PropTypes from 'prop-types';
import SvgSymbol from 'common/components/svg-symbol';
import './index.scss';

export default class Option extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    hilight: PropTypes.instanceOf(RegExp),
    isDisabled: PropTypes.bool,
    isFocused: PropTypes.bool,
    isSelected: PropTypes.bool,
    onSelect: PropTypes.func,
    searchValue: PropTypes.string,
    style: PropTypes.oneOf(['checkbox', 'radio', 'right-check']),
  };

  static defaultProps = {
    hilight: null,
    isSelected: false,
    onSelect: () => {},
    searchValue: null,
    style: 'checkbox',
  };

  /* Wraps given string with elements to create hilighted match */
  static applyHilight(children, regexp) {
    return children.map((child, index) => {
      // Element, don't bother recursing
      if (typeof child !== 'string') {
        return child;
      }

      // Generate hilighting effect
      const match = child.match(regexp);
      if (match && match[0].length > 0) {
        return Option.prepareMatch(child, match, index);
      }
      return child;
    });
  }

  /* Wraps given string with elements to create hilighted match */
  static prepareMatch(string, regexpMatch, elementIndex) {
    const value = regexpMatch[0];
    const index = regexpMatch.index;
    return (
      <span key={elementIndex}>
        {string.substring(0, index)}
        <span className={'Option-match'}>{value}</span>
        {string.substring(index + value.length, string.length)}
      </span>
    );
  }

  render() {
    let children = React.Children.toArray(this.props.children);

    // Found, filter through children possibly wrapping the found string with a
    // Hilight span
    // NOTE: does not recurse into sub-children
    if (this.props.hilight) {
      children = Option.applyHilight(children, this.props.hilight);
    }

    let rightElement = null;
    let leftElement = null;
    const classes = ['Option'];

    if (this.props.style === 'right-check') {
      // This is the drop-down select style, insert right check icon for
      // Selected option, and add proper classes
      if (this.props.isSelected) {
        rightElement = <SvgSymbol name={'check'} />;

        // Add 'selected' class
        classes.push('Option-selected');
      }
    } else {
      // Checkbox or Radio style
      const className = [
        'Option',
        this.props.style,
        this.props.isSelected ? 'checked' : 'unchecked',
      ].join('-');

      // TODO: these need to be fixed with proper SVGs (now just using unicode)
      const character = this.props.style === 'checkbox' ? '\u2714' : '\u2022';
      leftElement = (
        <div className={className}>
          {this.props.isSelected ? character : null}
        </div>
      );
    }

    if (this.props.isFocused) {
      classes.push('Option-focused');
    }

    if (this.props.isDisabled) {
      classes.push('Option-disabled');
    }

    return (
      <div className={classes.join(' ')} onClick={this.props.onSelect}>
        {leftElement}
        {children}
        {rightElement}
      </div>
    );
  }
}
